import React            from 'react';
import PropTypes        from 'prop-types';
import classNames       from 'classnames';
import { Bars }         from  'react-loader-spinner';

// import useMessage      from './useHeader';

import styles           from './Button.styl';

function Button(props) {
    const {
        className,
        children,
        loading,
        disabled,
        color,
        ...rest
    } = props;

    // const {} = useMessage();

    return  (
        <div
            className={classNames(styles.Button, className, {
                [styles.white]: color === 'white',
                [styles.secondary]: color === 'secondary',
                [styles.filled]: color === 'filled',
                [styles.gradient]: color === 'gradient',
                [styles.disabled]: loading || disabled
            })}
            {...rest}
        >
            {loading
                ? (
                    <Bars
                        height  = "20"
                        width   = "20"
                        color   = "#FFFFFF"
                        visible = {true}
                    />
                )
                : children
            }
        </div>
    );
}

Button.propTypes = {
    className : PropTypes.string,
    children  : PropTypes.node.isRequired,
    color     : PropTypes.string,
    loading   : PropTypes.bool,
    disabled  : PropTypes.bool
};

Button.defaultProps = {
    className : '',
    color     : 'default',
    loading   : false,
    disabled  : false
};

export default Button;
